import { createLagomorphaVuetify } from '@/app/createLagomorphaVuetify';
import { registerGlobalComponents } from '@/app/registerGlobalComponents';
import LandingView from '@/pages/Landing/Landing.vue';
import { createApp, createSSRApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import LandingShell from './LandingShell.vue';
import './landing-bootstrap';

import '@/styles/main.scss';
import '@/styles/variables.scss';
import '@/styles/vuetify-overrides.scss';
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

const appRoot = typeof document !== 'undefined' ? document.getElementById('app') : null;
const shouldHydrate = !!appRoot && appRoot.childNodes.length > 0;
const app = shouldHydrate ? createSSRApp(LandingShell) : createApp(LandingShell);

const router = createRouter({
    history: createWebHistory(),
    routes: [
        { path: '/', name: 'landing', component: LandingView },
        { path: '/landing', name: 'landing.preview', component: LandingView },
    ],
});

app.use(router);
app.use(createLagomorphaVuetify({ forceTheme: 'naiveLight' }));
registerGlobalComponents(app);

void router.isReady().then(() => {
    app.mount('#app');
    document.dispatchEvent(new Event('landing:mounted'));
});
